import { useEffect, useState } from "react";
import api from "@/lib/api";
import { X, CheckCircle, Clock, Eye, PencilSimple, Lock, ArrowsClockwise } from "@phosphor-icons/react";

export default function MessageInfoModal({ msgId, onClose }) {
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!msgId) return;
    api.get(`/team-chat/messages/${msgId}/info`)
      .then(r => setInfo(r.data))
      .catch(e => setErr(e.response?.data?.detail || e.message));
  }, [msgId]);

  if (!msgId) return null;
  const fmt = (iso) => iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "medium" }) : "—";

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="msg-info-modal">
      <div className="bg-white w-full max-w-md border border-[var(--border)] shadow-2xl">
        <div className="px-5 py-4 border-b border-[var(--border)] flex items-center justify-between">
          <div>
            <div className="text-[10px] tracking-widest text-[var(--text-muted)] font-semibold">MESSAGE</div>
            <div className="font-display font-bold text-[18px]">Info</div>
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-[var(--bg-sidebar)]" data-testid="msg-info-close"><X size={16} /></button>
        </div>
        <div className="px-5 py-5 space-y-3" data-testid="msg-info-body">
          {err && <div className="text-[12px] text-[var(--danger)]">{err}</div>}
          {info && (
            <>
              <Row icon={CheckCircle} label="Sent" value={fmt(info.sent_at)} />
              <Row icon={Clock} label="Delivered" value={fmt(info.delivered_at)} />
              <div>
                <div className="flex items-center gap-2 text-[12px] uppercase tracking-widest text-[var(--text-muted)] font-semibold">
                  <Eye size={12} /> Read
                </div>
                <ul className="mt-1.5 ml-5 space-y-1" data-testid="msg-info-read-status">
                  {info.read_status.length === 0 && <li className="text-[12px] text-[var(--text-muted)]">No recipients</li>}
                  {info.read_status.map(r => (
                    <li key={r.id} className="text-[13px] flex items-center justify-between">
                      <span>{r.name}</span>
                      <span className="font-mono text-[11px] text-[var(--text-secondary)]">{r.read_at ? fmt(r.read_at) : "—"}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <Row icon={PencilSimple} label="Edited" value={info.edited ? "Yes (" + fmt(info.edited_at) + ")" : "No"} />
              <Row icon={ArrowsClockwise} label="Forwarded" value={info.forwarded ? "Yes" : "No"} />
              <Row icon={Lock} label="Encrypted" value={info.encrypted ? "Yes" : "No"} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function Row({ icon: Icon, label, value }) {
  return (
    <div>
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-[var(--text-muted)] font-semibold">
        <Icon size={12} /> {label}
      </div>
      <div className="text-[13px] ml-5 mt-0.5">{value}</div>
    </div>
  );
}
